module.exports = __webpack_public_path__ + "img/fuelmetrics (5).8fb3fa27.png";